var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pickl && Object.keys(_vm.pickl).length > 0
    ? _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered modal-xl",
          staticStyle: { "max-width": "95%" }
        },
        [
          _c("div", { class: _vm.isMixCampaign ? "modal-content" : "" }, [
            _vm.isMixCampaign
              ? _c("div", { staticClass: "modal-header" }, [
                  !_vm.brand && _vm.pickl.status === "COMPLETED"
                    ? _c("h2", [_vm._v("Approve Workflow")])
                    : _c("h2", [_vm._v("PICKL Details")]),
                  _c("button", {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  }),
                  _vm.$store.state.userData.role === "super-admin" &&
                  (_vm.pickl.status === "COMPLETED" ||
                    _vm.pickl.status === "APPROVED" ||
                    _vm.pickl.status === "REJECTED") &&
                  !_vm.brand
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-positive pull-right",
                          attrs: {
                            type: "button",
                            "data-toggle": "modal",
                            "data-target": "#task-sync-log-popup"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    View Image Uploading Error Logs\n                  "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.$store.state.userData.role != "staff"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-positive pull-right",
                          attrs: { type: "button" },
                          on: { click: _vm.generateShareLink }
                        },
                        [_vm._v("Share Task ")]
                      )
                    : _vm._e(),
                  _vm.sharedLinkGenerated
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.sharedLink,
                            expression: "sharedLink"
                          }
                        ],
                        staticClass: "pull-right",
                        attrs: { type: "text" },
                        domProps: { value: _vm.sharedLink },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.sharedLink = $event.target.value
                          }
                        }
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _c("div", { class: _vm.isMixCampaign ? "modal-body" : "" }, [
              !_vm.isMixCampaign
                ? _c(
                    "div",
                    [
                      (_vm.pickl.status === "COMPLETED" ||
                        _vm.pickl.status === "APPROVED" ||
                        _vm.pickl.status === "REJECTED") &&
                      _vm.pickl.user_pickl &&
                      _vm.pickl.user_pickl.user
                        ? _c("div", { staticClass: "pickl-summary-bar" }, [
                            _c(
                              "div",
                              { staticClass: "pickl-summary-categories" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "pickl-summary-category" },
                                  [
                                    _c(
                                      "h4",
                                      { staticClass: "pickl-category-title" },
                                      [_vm._v("User")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "pickl-category-content" },
                                      [
                                        _c("div", [
                                          _c("strong", [_vm._v("Name:")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.pickl.user_pickl.user
                                                  .name || "—"
                                              )
                                          )
                                        ]),
                                        _vm.$store.state.userData.role ===
                                          "super-admin" &&
                                        _vm.pickl.user_pickl.user.mobile_number
                                          ? _c("div", [
                                              _c("strong", [_vm._v("Phone:")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("phone")(
                                                      _vm.pickl.user_pickl.user
                                                        .mobile_number
                                                    )
                                                  )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _c("CommonPicklDetails", {
                        attrs: {
                          popupId: "pickl-details-popup",
                          brand: _vm.isBrand,
                          pickl: _vm.pickl
                        },
                        on: {
                          reversedRejection: _vm.getPicklDetails,
                          statusUpdated: _vm.redirectToPicklsPage,
                          updatePicklDetails: _vm.getPicklDetails
                        }
                      })
                    ],
                    1
                  )
                : _c("div", [
                    _c("div", { staticClass: "pickl-summary-bar" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pickl-summary-row pickl-campaign-name-row"
                        },
                        [
                          _c("span", { staticClass: "pickl-summary-name" }, [
                            _vm._v(_vm._s(_vm.pickl.name || "Mix campaign"))
                          ])
                        ]
                      ),
                      _c("div", { staticClass: "pickl-summary-categories" }, [
                        _vm.pickl.store || _vm.pickl.store_location
                          ? _c(
                              "div",
                              { staticClass: "pickl-summary-category" },
                              [
                                _c(
                                  "h4",
                                  { staticClass: "pickl-category-title" },
                                  [_vm._v("Location")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "pickl-category-content" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "pickl-meta-store" },
                                      [
                                        _vm.getStoreImage(_vm.pickl)
                                          ? _c("img", {
                                              staticClass:
                                                "pickl-summary-store-img",
                                              attrs: {
                                                src: _vm.getStoreImage(
                                                  _vm.pickl
                                                ),
                                                alt: _vm.getStoreName(_vm.pickl)
                                              }
                                            })
                                          : _vm._e(),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.getStoreName(_vm.pickl))
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm.pickl.store_location &&
                                    _vm.formatStoreLocationAddress(
                                      _vm.pickl.store_location
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "pickl-meta-address" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatStoreLocationAddress(
                                                  _vm.pickl.store_location
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        (_vm.pickl.status === "COMPLETED" ||
                          _vm.pickl.status === "APPROVED" ||
                          _vm.pickl.status === "REJECTED") &&
                        _vm.pickl.user_pickl &&
                        _vm.pickl.user_pickl.user
                          ? _c(
                              "div",
                              { staticClass: "pickl-summary-category" },
                              [
                                _c(
                                  "h4",
                                  { staticClass: "pickl-category-title" },
                                  [_vm._v("User")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "pickl-category-content" },
                                  [
                                    _c("div", [
                                      _c("strong", [_vm._v("Name:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.pickl.user_pickl.user.name ||
                                              "—"
                                          )
                                      )
                                    ]),
                                    _vm.$store.state.userData.role ===
                                      "super-admin" &&
                                    _vm.pickl.user_pickl.user.mobile_number
                                      ? _c("div", [
                                          _c("strong", [_vm._v("Phone:")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("phone")(
                                                  _vm.pickl.user_pickl.user
                                                    .mobile_number
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "pickl-summary-category" }, [
                          _c("h4", { staticClass: "pickl-category-title" }, [
                            _vm._v("Dates & status")
                          ]),
                          _c("div", { staticClass: "pickl-category-content" }, [
                            _vm.pickl.start_date_time
                              ? _c("span", { staticClass: "pickl-meta-item" }, [
                                  _c("strong", [_vm._v("Start:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatSummaryDate(
                                          _vm.pickl.start_date_time
                                        )
                                      )
                                  )
                                ])
                              : _vm._e(),
                            _vm.pickl.user_pickl &&
                            _vm.pickl.user_pickl.completed_at
                              ? _c("span", { staticClass: "pickl-meta-item" }, [
                                  _c("strong", [_vm._v("Completed At:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formattedPhpTime")(
                                          _vm.formatSummaryDate(
                                            _vm.pickl.user_pickl.completed_at
                                          )
                                        )
                                      )
                                  )
                                ])
                              : _vm._e(),
                            _vm.pickl.credits != null ||
                            _vm.getReimbursementCredits(_vm.pickl) != null
                              ? _c("span", { staticClass: "pickl-meta-item" }, [
                                  _c("strong", [_vm._v("Insentive:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatCreditsDisplay(_vm.pickl)
                                      )
                                  )
                                ])
                              : _vm._e(),
                            _c(
                              "span",
                              {
                                class: [
                                  "pickl-status-badge",
                                  "pickl-status-" +
                                    (_vm.pickl.status || "").toLowerCase()
                                ]
                              },
                              [_vm._v(_vm._s(_vm.pickl.status || "—"))]
                            ),
                            _vm.pickl.brand && _vm.pickl.brand.name
                              ? _c("span", { staticClass: "pickl-meta-item" }, [
                                  _c("strong", [_vm._v("Company:")]),
                                  _vm._v(" " + _vm._s(_vm.pickl.brand.name))
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _c(
                      "ul",
                      { staticClass: "nav nav-tabs pickl-workflow-tabs" },
                      [
                        _vm._l(_vm.workflowTabs, function(activity, index) {
                          return _c(
                            "li",
                            { key: index, class: { active: index === 0 } },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#workflow-tab-" + index
                                  }
                                },
                                [
                                  _c("span", { staticClass: "tab-index" }, [
                                    _vm._v(_vm._s(index + 1))
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(activity.label) +
                                      "\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        !_vm.brand && _vm.pickl.user_pickl
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#approve-reject-tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            Approve/Reject\n          "
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "tab-content" },
                      [
                        _vm._l(_vm.workflowTabs, function(activity, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class: [
                                "tab-pane",
                                "fade",
                                { "in active": index === 0 }
                              ],
                              attrs: { id: "workflow-tab-" + index }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row pickl-tab-content-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      class:
                                        activity.type === "survey"
                                          ? "col-sm-12"
                                          : "col-sm-6"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "section-label section-label-activity"
                                        },
                                        [_vm._v("Activity brief")]
                                      ),
                                      activity.type === "product"
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              _vm.getProductActivityItems(
                                                activity
                                              ),
                                              function(productItem, pIndex) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: pIndex,
                                                    staticClass: "mb20"
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticStyle: {
                                                          color: "#333"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Product " +
                                                            _vm._s(pIndex + 1)
                                                        )
                                                      ]
                                                    ),
                                                    productItem.product
                                                      ? _c("div", [
                                                          productItem.description
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mb10"
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      "Description:"
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        productItem.description
                                                                      ) +
                                                                      "\n                  "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          productItem.product
                                                            .tasks &&
                                                          productItem.product
                                                            .tasks.length > 0
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mb15"
                                                                },
                                                                [
                                                                  _c("h4", [
                                                                    _vm._v(
                                                                      "Images Reqested:"
                                                                    )
                                                                  ]),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "row"
                                                                    },
                                                                    _vm._l(
                                                                      productItem
                                                                        .product
                                                                        .tasks,
                                                                      function(
                                                                        taskItem,
                                                                        tIndex
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: tIndex,
                                                                            staticClass:
                                                                              "col-xs-6 col-md-3 mb10"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "pickl-detail-card white-bg text-center pickl-image-card"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pickl-image-wrap"
                                                                                  },
                                                                                  [
                                                                                    taskItem.task &&
                                                                                    taskItem
                                                                                      .task
                                                                                      .image
                                                                                      ? _c(
                                                                                          "img",
                                                                                          {
                                                                                            attrs: {
                                                                                              src:
                                                                                                taskItem
                                                                                                  .task
                                                                                                  .image +
                                                                                                "?w=200&q=80&h=200&fit=crop",
                                                                                              alt:
                                                                                                taskItem
                                                                                                  .task
                                                                                                  .name ||
                                                                                                "Task"
                                                                                            },
                                                                                            on: {
                                                                                              error: function(
                                                                                                $event
                                                                                              ) {
                                                                                                $event.target.src =
                                                                                                  "/img/default_task_image.png"
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ]
                                                                                ),
                                                                                taskItem.task
                                                                                  ? _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "pickl-image-caption",
                                                                                        attrs: {
                                                                                          title:
                                                                                            taskItem
                                                                                              .task
                                                                                              .name
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            taskItem
                                                                                              .task
                                                                                              .name
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e()
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          productItem.product
                                                            .images &&
                                                          productItem.product
                                                            .images.length > 0
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mb15"
                                                                },
                                                                [
                                                                  _c("h4", [
                                                                    _vm._v(
                                                                      "Items:"
                                                                    )
                                                                  ]),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "row"
                                                                    },
                                                                    _vm._l(
                                                                      productItem
                                                                        .product
                                                                        .images,
                                                                      function(
                                                                        image,
                                                                        imgIndex
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: imgIndex,
                                                                            staticClass:
                                                                              "col-xs-6 col-md-3 mb10"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "pickl-detail-card white-bg text-center pickl-image-card"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pickl-image-wrap"
                                                                                  },
                                                                                  [
                                                                                    image.image
                                                                                      ? _c(
                                                                                          "viewer",
                                                                                          {
                                                                                            attrs: {
                                                                                              images: [
                                                                                                image
                                                                                              ],
                                                                                              options:
                                                                                                _vm.viewerOptions
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "img",
                                                                                              {
                                                                                                staticStyle: {
                                                                                                  cursor:
                                                                                                    "pointer"
                                                                                                },
                                                                                                attrs: {
                                                                                                  src:
                                                                                                    image.image +
                                                                                                    "?w=200&q=80&h=200&fit=crop",
                                                                                                  alt:
                                                                                                    image.description ||
                                                                                                    "Product"
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                image.description
                                                                                  ? _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "pickl-image-caption",
                                                                                        attrs: {
                                                                                          title:
                                                                                            image.description
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            image.description
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e()
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : activity.type === "selfie"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-detail-card white-bg"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticStyle: {
                                                      color: "#333"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(activity.label)
                                                    )
                                                  ]
                                                ),
                                                activity.data.description
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Description:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .description
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        : activity.type === "video"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-detail-card white-bg"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticStyle: {
                                                      color: "#333"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(activity.label)
                                                    )
                                                  ]
                                                ),
                                                activity.data.description
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Description:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .description
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        : activity.type === "survey"
                                        ? _c(
                                            "div",
                                            _vm._l(activity.data, function(
                                              surveyItem,
                                              sIndex
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: sIndex,
                                                  staticClass: "mb20"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pickl-detail-card white-bg"
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticStyle: {
                                                            color: "#333"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Survey " +
                                                              _vm._s(sIndex + 1)
                                                          )
                                                        ]
                                                      ),
                                                      _vm.getSurveyDetails(
                                                        surveyItem
                                                      )
                                                        ? [
                                                            _c(
                                                              "h4",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#808080"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getSurveyDetails(
                                                                      surveyItem
                                                                    ).title
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm.getSurveyDetails(
                                                              surveyItem
                                                            ).description
                                                              ? _c("p", [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      "Description:"
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.getSurveyDetails(
                                                                          surveyItem
                                                                        )
                                                                          .description
                                                                      ) +
                                                                      "\n                    "
                                                                  )
                                                                ])
                                                              : _vm._e(),
                                                            _vm.getSurveyQuestions(
                                                              surveyItem
                                                            ).length > 0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "mt15"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "h4",
                                                                      {
                                                                        staticStyle: {
                                                                          color:
                                                                            "#808080"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Questions & Answers"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "row survey-questions-row"
                                                                      },
                                                                      _vm._l(
                                                                        _vm.getSurveyQuestions(
                                                                          surveyItem
                                                                        ),
                                                                        function(
                                                                          question,
                                                                          qIndex
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              key: qIndex,
                                                                              staticClass:
                                                                                "col-sm-6 mb15 survey-question-block"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "survey-question-collapse"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "button",
                                                                                    {
                                                                                      staticClass:
                                                                                        "survey-question-toggle",
                                                                                      attrs: {
                                                                                        type:
                                                                                          "button",
                                                                                        "aria-label": _vm.isSurveyQuestionCollapsed(
                                                                                          index,
                                                                                          sIndex,
                                                                                          qIndex
                                                                                        )
                                                                                          ? "Expand"
                                                                                          : "Collapse"
                                                                                      },
                                                                                      on: {
                                                                                        click: function(
                                                                                          $event
                                                                                        ) {
                                                                                          $event.stopPropagation()
                                                                                          return _vm.toggleSurveyQuestion(
                                                                                            index,
                                                                                            sIndex,
                                                                                            qIndex
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                              " +
                                                                                          _vm._s(
                                                                                            _vm.isSurveyQuestionCollapsed(
                                                                                              index,
                                                                                              sIndex,
                                                                                              qIndex
                                                                                            )
                                                                                              ? "+"
                                                                                              : "−"
                                                                                          ) +
                                                                                          "\n                            "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "survey-question-header",
                                                                                      on: {
                                                                                        click: function(
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.toggleSurveyQuestion(
                                                                                            index,
                                                                                            sIndex,
                                                                                            qIndex
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "survey-question"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "strong",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Q" +
                                                                                                  _vm._s(
                                                                                                    qIndex +
                                                                                                      1
                                                                                                  ) +
                                                                                                  ":"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                question.question
                                                                                              )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "show",
                                                                                      rawName:
                                                                                        "v-show",
                                                                                      value: !_vm.isSurveyQuestionCollapsed(
                                                                                        index,
                                                                                        sIndex,
                                                                                        qIndex
                                                                                      ),
                                                                                      expression:
                                                                                        "!isSurveyQuestionCollapsed(index, sIndex, qIndex)"
                                                                                    }
                                                                                  ],
                                                                                  staticClass:
                                                                                    "survey-question-body"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "survey-question-type"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "strong",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Type:"
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            question.questionType ||
                                                                                              question.question_type ||
                                                                                              "—"
                                                                                          )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm.getSurveyAnswerOptions(
                                                                                    question
                                                                                  )
                                                                                    .length >
                                                                                  0
                                                                                    ? _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mt10"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "strong",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Answer options:"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "ul",
                                                                                            {
                                                                                              staticClass:
                                                                                                "survey-answers-list"
                                                                                            },
                                                                                            _vm._l(
                                                                                              _vm.getSurveyAnswerOptions(
                                                                                                question
                                                                                              ),
                                                                                              function(
                                                                                                answer,
                                                                                                aIndex
                                                                                              ) {
                                                                                                return _c(
                                                                                                  "li",
                                                                                                  {
                                                                                                    key: aIndex,
                                                                                                    class: {
                                                                                                      "survey-answer-selected": _vm.isSurveyAnswerSelected(
                                                                                                        surveyItem,
                                                                                                        question.id ||
                                                                                                          question.questionId,
                                                                                                        answer.id ||
                                                                                                          answer.answerId
                                                                                                      )
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "\n                                  " +
                                                                                                        _vm._s(
                                                                                                          answer.answerOption ||
                                                                                                            answer.answer_option
                                                                                                        ) +
                                                                                                        "\n                                  "
                                                                                                    ),
                                                                                                    _vm.isSurveyAnswerSelected(
                                                                                                      surveyItem,
                                                                                                      question.id ||
                                                                                                        question.questionId,
                                                                                                      answer.id ||
                                                                                                        answer.answerId
                                                                                                    )
                                                                                                      ? _c(
                                                                                                          "span",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "survey-selected-badge"
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "Selected"
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      : _vm._e()
                                                                                                  ]
                                                                                                )
                                                                                              }
                                                                                            ),
                                                                                            0
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm.getSurveyUserAnswerForQuestion(
                                                                                        surveyItem,
                                                                                        question.id ||
                                                                                          question.questionId
                                                                                      )
                                                                                    ? _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mt10"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "strong",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "User answer:"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "span",
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  _vm.getSurveyUserAnswerText(
                                                                                                    surveyItem,
                                                                                                    question
                                                                                                  )
                                                                                                )
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e()
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        : activity.type === "watch"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-detail-card white-bg"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticStyle: {
                                                      color: "#333"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(activity.label)
                                                    )
                                                  ]
                                                ),
                                                activity.data.description
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Description:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .description
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.youtubeEmbedSrc(
                                                  activity.data
                                                )
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb15" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "embed-responsive embed-responsive-16by9",
                                                            staticStyle: {
                                                              "max-width":
                                                                "640px",
                                                              "min-height":
                                                                "200px"
                                                            }
                                                          },
                                                          [
                                                            _c("iframe", {
                                                              staticClass:
                                                                "embed-responsive-item",
                                                              attrs: {
                                                                src: _vm.youtubeEmbedSrc(
                                                                  activity.data
                                                                ),
                                                                allow:
                                                                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                                                allowfullscreen:
                                                                  "",
                                                                title:
                                                                  "YouTube video"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : activity.data.youtubeUrl ||
                                                    activity.data.website_link
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Video URL:")
                                                        ]),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                activity.data
                                                                  .website_link ||
                                                                activity.data
                                                                  .youtubeUrl,
                                                              target: "_blank",
                                                              rel:
                                                                "noopener noreferrer"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                activity.data
                                                                  .website_link ||
                                                                  activity.data
                                                                    .youtubeUrl
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        : activity.type === "url-visit"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-detail-card white-bg"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticStyle: {
                                                      color: "#333"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(activity.label)
                                                    )
                                                  ]
                                                ),
                                                activity.data.description
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Description:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .description
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                activity.data.url
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("URL:")
                                                        ]),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                activity.data
                                                                  .url,
                                                              target: "_blank",
                                                              rel:
                                                                "noopener noreferrer"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                activity.data
                                                                  .url
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        : activity.type === "app-install"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-detail-card white-bg"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticStyle: {
                                                      color: "#333"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(activity.label)
                                                    )
                                                  ]
                                                ),
                                                activity.data.description
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Description:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .description
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                activity.data.appName ||
                                                activity.data.title
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("App Name:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .appName ||
                                                                activity.data
                                                                  .title
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                activity.data.ios_link ||
                                                activity.data.iosLink
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("iOS Link:")
                                                        ]),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                activity.data
                                                                  .ios_link ||
                                                                activity.data
                                                                  .iosLink,
                                                              target: "_blank",
                                                              rel:
                                                                "noopener noreferrer"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                activity.data
                                                                  .ios_link ||
                                                                  activity.data
                                                                    .iosLink
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                activity.data.android_link ||
                                                activity.data.androidLink
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Android Link:"
                                                          )
                                                        ]),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                activity.data
                                                                  .android_link ||
                                                                activity.data
                                                                  .androidLink,
                                                              target: "_blank",
                                                              rel:
                                                                "noopener noreferrer"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                activity.data
                                                                  .android_link ||
                                                                  activity.data
                                                                    .androidLink
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                activity.data.link_id &&
                                                !activity.data.ios_link &&
                                                !activity.data.android_link &&
                                                !activity.data.iosLink &&
                                                !activity.data.androidLink
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Link:")
                                                        ]),
                                                        _vm._v(
                                                          " Selected link (ID: " +
                                                            _vm._s(
                                                              activity.data
                                                                .link_id
                                                            ) +
                                                            ")\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.getLinkActivityImages(
                                                  activity.data
                                                ).length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "mb15 mt15"
                                                      },
                                                      [
                                                        _c("h4", [
                                                          _vm._v("Images")
                                                        ]),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "row"
                                                          },
                                                          _vm._l(
                                                            _vm.getLinkActivityImages(
                                                              activity.data
                                                            ),
                                                            function(
                                                              img,
                                                              imgIndex
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    "app-img-" +
                                                                    imgIndex,
                                                                  staticClass:
                                                                    "col-xs-6 col-md-3 mb10"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "pickl-detail-card white-bg text-center pickl-image-card"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pickl-image-wrap"
                                                                        },
                                                                        [
                                                                          _vm.getLinkImageSrc(
                                                                            img
                                                                          )
                                                                            ? _c(
                                                                                "viewer",
                                                                                {
                                                                                  attrs: {
                                                                                    images: [
                                                                                      img
                                                                                    ],
                                                                                    options:
                                                                                      _vm.viewerOptions
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      staticStyle: {
                                                                                        cursor:
                                                                                          "pointer"
                                                                                      },
                                                                                      attrs: {
                                                                                        src: _vm.getLinkImageSrc(
                                                                                          img
                                                                                        ),
                                                                                        alt:
                                                                                          img.description ||
                                                                                          "Link"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ],
                                                                        1
                                                                      ),
                                                                      img.description
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "pickl-image-caption",
                                                                              attrs: {
                                                                                title:
                                                                                  img.description
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  img.description
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        : activity.type === "review"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-detail-card white-bg"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticStyle: {
                                                      color: "#333"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(activity.label)
                                                    )
                                                  ]
                                                ),
                                                activity.data.description
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Description:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .description
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                activity.data.website_link ||
                                                activity.data.url
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Review URL:")
                                                        ]),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                activity.data
                                                                  .website_link ||
                                                                activity.data
                                                                  .url,
                                                              target: "_blank",
                                                              rel:
                                                                "noopener noreferrer"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                activity.data
                                                                  .website_link ||
                                                                  activity.data
                                                                    .url
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                activity.data.link_id &&
                                                !activity.data.website_link &&
                                                !activity.data.url
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Link:")
                                                        ]),
                                                        _vm._v(
                                                          " Selected link (ID: " +
                                                            _vm._s(
                                                              activity.data
                                                                .link_id
                                                            ) +
                                                            ")\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.getLinkActivityImages(
                                                  activity.data
                                                ).length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "mb15 mt15"
                                                      },
                                                      [
                                                        _c("h4", [
                                                          _vm._v("Images")
                                                        ]),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "row"
                                                          },
                                                          _vm._l(
                                                            _vm.getLinkActivityImages(
                                                              activity.data
                                                            ),
                                                            function(
                                                              img,
                                                              imgIndex
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    "review-img-" +
                                                                    imgIndex,
                                                                  staticClass:
                                                                    "col-xs-6 col-md-3 mb10"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "pickl-detail-card white-bg text-center pickl-image-card"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pickl-image-wrap"
                                                                        },
                                                                        [
                                                                          _vm.getLinkImageSrc(
                                                                            img
                                                                          )
                                                                            ? _c(
                                                                                "viewer",
                                                                                {
                                                                                  attrs: {
                                                                                    images: [
                                                                                      img
                                                                                    ],
                                                                                    options:
                                                                                      _vm.viewerOptions
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      staticStyle: {
                                                                                        cursor:
                                                                                          "pointer"
                                                                                      },
                                                                                      attrs: {
                                                                                        src: _vm.getLinkImageSrc(
                                                                                          img
                                                                                        ),
                                                                                        alt:
                                                                                          img.description ||
                                                                                          "Link"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ],
                                                                        1
                                                                      ),
                                                                      img.description
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "pickl-image-caption",
                                                                              attrs: {
                                                                                title:
                                                                                  img.description
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  img.description
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        : activity.type === "buy-me"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-detail-card white-bg"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticStyle: {
                                                      color: "#333"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(activity.label)
                                                    )
                                                  ]
                                                ),
                                                activity.data.description
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Description:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .description
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                activity.data
                                                  .reimbursementCredits !=
                                                  null &&
                                                activity.data
                                                  .reimbursementCredits !== ""
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Reimbursement Credits:"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .reimbursementCredits
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        : activity.type === "deal-drop"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-detail-card white-bg"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticStyle: {
                                                      color: "#333"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(activity.label)
                                                    )
                                                  ]
                                                ),
                                                activity.data.description
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Description:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .description
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                activity.data.coupon
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Coupon:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .coupon.name ||
                                                                activity.data
                                                                  .coupon.title
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : activity.data.couponId
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Coupon ID:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .couponId
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        : activity.type === "photo"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-detail-card white-bg"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticStyle: {
                                                      color: "#333"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(activity.label)
                                                    )
                                                  ]
                                                ),
                                                activity.data.description
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Description:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .description
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.getPhotoActivityTasks(
                                                  activity
                                                ).length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "mb15 mt15"
                                                      },
                                                      [
                                                        _c("h4", [
                                                          _vm._v(
                                                            "Required photos"
                                                          )
                                                        ]),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "row"
                                                          },
                                                          _vm._l(
                                                            _vm.getPhotoActivityTasks(
                                                              activity
                                                            ),
                                                            function(
                                                              slot,
                                                              slotIdx
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    "photo-task-" +
                                                                    slotIdx,
                                                                  staticClass:
                                                                    "col-xs-6 col-md-3 mb10"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "pickl-detail-card white-bg text-center pickl-image-card"
                                                                    },
                                                                    [
                                                                      slot.task &&
                                                                      (slot.task
                                                                        .image ||
                                                                        _vm.getPhotoTaskImageUrl(
                                                                          slot.task
                                                                        ))
                                                                        ? [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "pickl-image-wrap"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "viewer",
                                                                                  {
                                                                                    attrs: {
                                                                                      images: [
                                                                                        slot.task
                                                                                      ],
                                                                                      options:
                                                                                        _vm.viewerOptions
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        staticStyle: {
                                                                                          cursor:
                                                                                            "pointer"
                                                                                        },
                                                                                        attrs: {
                                                                                          src: _vm.getPhotoTaskImageUrl(
                                                                                            slot.task
                                                                                          ),
                                                                                          alt:
                                                                                            slot
                                                                                              .task
                                                                                              .name ||
                                                                                            "Task"
                                                                                        },
                                                                                        on: {
                                                                                          error: function(
                                                                                            $event
                                                                                          ) {
                                                                                            $event.target.src =
                                                                                              "/img/default_task_image.png"
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            slot.task &&
                                                                            slot
                                                                              .task
                                                                              .name
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pickl-image-caption",
                                                                                    attrs: {
                                                                                      title:
                                                                                        slot
                                                                                          .task
                                                                                          .name
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        slot
                                                                                          .task
                                                                                          .name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          ]
                                                                        : _vm._e()
                                                                    ],
                                                                    2
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        : _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-detail-card white-bg"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticStyle: {
                                                      color: "#333"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(activity.label)
                                                    )
                                                  ]
                                                ),
                                                activity.data.description
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mb10" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Description:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              activity.data
                                                                .description
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                    ]
                                  ),
                                  activity.type !== "survey"
                                    ? _c("div", { staticClass: "col-sm-6" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "section-label section-label-response"
                                          },
                                          [_vm._v("What the User submitted")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pickl-detail-card white-bg picklr-response-box"
                                          },
                                          [
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "picklr-response-title",
                                                staticStyle: { color: "#333" }
                                              },
                                              [_vm._v("User Response")]
                                            ),
                                            (activity.type === "watch" ||
                                              activity.type ===
                                                "watch-video") &&
                                            _vm.pickl.user_pickl &&
                                            _vm.pickl.user_pickl.status ===
                                              "COMPLETED"
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "mb0 picklr-response-text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "User has watched the full video."
                                                    )
                                                  ]
                                                )
                                              : _vm.getActivityUserResponses(
                                                  activity
                                                ).length > 0
                                              ? [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    _vm._l(
                                                      _vm.getActivityUserResponses(
                                                        activity
                                                      ),
                                                      function(resp, rIdx) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: "resp-" + rIdx,
                                                            staticClass:
                                                              "col-xs-6 col-md-3 mb10"
                                                          },
                                                          [
                                                            _vm.getUserResponseImageUrl(
                                                              resp,
                                                              activity.type
                                                            )
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "pickl-detail-card white-bg text-center pickl-image-card"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "pickl-image-wrap"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "viewer",
                                                                          {
                                                                            attrs: {
                                                                              images: [
                                                                                resp
                                                                              ],
                                                                              options:
                                                                                _vm.viewerOptions
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticStyle: {
                                                                                  cursor:
                                                                                    "pointer"
                                                                                },
                                                                                attrs: {
                                                                                  src: _vm.getUserResponseImageUrl(
                                                                                    resp,
                                                                                    activity.type
                                                                                  ),
                                                                                  alt:
                                                                                    "User response"
                                                                                },
                                                                                on: {
                                                                                  error: function(
                                                                                    $event
                                                                                  ) {
                                                                                    $event.target.src =
                                                                                      "/img/default_product_image.png"
                                                                                  }
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    resp.task &&
                                                                    (resp.task
                                                                      .name ||
                                                                      resp.task
                                                                        .display_name)
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "pickl-image-caption",
                                                                            attrs: {
                                                                              title:
                                                                                resp
                                                                                  .task
                                                                                  .display_name ||
                                                                                resp
                                                                                  .task
                                                                                  .name
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                resp
                                                                                  .task
                                                                                  .display_name ||
                                                                                  resp
                                                                                    .task
                                                                                    .name
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "pickl-image-caption"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Response"
                                                                            )
                                                                          ]
                                                                        ),
                                                                    resp.created_at
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "pickl-image-caption-secondary"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.formatResponseDate(
                                                                                  resp.created_at
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              : _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-muted mb0 picklr-response-empty"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "No response yet for this activity."
                                                    )
                                                  ]
                                                )
                                          ],
                                          2
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane fade",
                            attrs: { id: "approve-reject-tab" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "pickl-detail-card white-bg" },
                              [
                                !_vm.brand && _vm.pickl.user_pickl
                                  ? _c("div", { staticClass: "row mt20" }, [
                                      _c("div", { staticClass: "col-xs-12" }, [
                                        _c(
                                          "div",
                                          { staticClass: "pickl-rating-card" },
                                          [
                                            _vm.pickl.status === "PENDING" ||
                                            _vm.pickl.status === "ACCEPTED" ||
                                            _vm.pickl.status === "EXPIRED"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pickl-rating-unavailable"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "completion-time"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Rating not available"
                                                        )
                                                      ]
                                                    ),
                                                    _vm.pickl.user_pickl
                                                      .need_review === "Yes"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "pickl-rating-attention"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "completion-time"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "ATTENTION NEEDED"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : !_vm.brand &&
                                                _vm.pickl.status === "COMPLETED"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pickl-rating-form"
                                                  },
                                                  [
                                                    _c(
                                                      "h5",
                                                      {
                                                        staticClass:
                                                          "pickl-rating-title"
                                                      },
                                                      [_vm._v("User Rating")]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pickl-rating-stars",
                                                        on: {
                                                          mouseout: function(
                                                            $event
                                                          ) {
                                                            _vm.hoverRating = 0
                                                          }
                                                        }
                                                      },
                                                      _vm._l(5, function(i) {
                                                        return _c(
                                                          "span",
                                                          {
                                                            key: i,
                                                            on: {
                                                              mouseover: function(
                                                                $event
                                                              ) {
                                                                _vm.hoverRating = i
                                                              },
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.rating = i
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: _vm.getImagePath(
                                                                  i
                                                                ),
                                                                alt:
                                                                  "Star rating"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      }),
                                                      0
                                                    ),
                                                    _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.adminNote,
                                                          expression:
                                                            "adminNote"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "pickl-rating-notes",
                                                      attrs: {
                                                        maxlength: "120",
                                                        placeholder:
                                                          "Notes for user(optional)"
                                                      },
                                                      domProps: {
                                                        value: _vm.adminNote
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.adminNote =
                                                            $event.target.value
                                                        }
                                                      }
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pickl-rating-checkboxes"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "pickl-rating-check"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.showNotesToBrand,
                                                                  expression:
                                                                    "showNotesToBrand"
                                                                }
                                                              ],
                                                              attrs: {
                                                                type:
                                                                  "checkbox",
                                                                id:
                                                                  "popup-show-notes-to-brand"
                                                              },
                                                              domProps: {
                                                                checked: Array.isArray(
                                                                  _vm.showNotesToBrand
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.showNotesToBrand,
                                                                      null
                                                                    ) > -1
                                                                  : _vm.showNotesToBrand
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm.showNotesToBrand,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c = $$el.checked
                                                                      ? true
                                                                      : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v = null,
                                                                      $$i = _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        (_vm.showNotesToBrand = $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        (_vm.showNotesToBrand = $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                    }
                                                                  } else {
                                                                    _vm.showNotesToBrand = $$c
                                                                  }
                                                                }
                                                              }
                                                            }),
                                                            _c("span", [
                                                              _vm._v(
                                                                "Show notes to company"
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "pickl-rating-check"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.needReview,
                                                                  expression:
                                                                    "needReview"
                                                                }
                                                              ],
                                                              attrs: {
                                                                type:
                                                                  "checkbox",
                                                                id:
                                                                  "popup-need-review"
                                                              },
                                                              domProps: {
                                                                checked: Array.isArray(
                                                                  _vm.needReview
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.needReview,
                                                                      null
                                                                    ) > -1
                                                                  : _vm.needReview
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm.needReview,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c = $$el.checked
                                                                      ? true
                                                                      : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v = null,
                                                                      $$i = _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        (_vm.needReview = $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        (_vm.needReview = $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                    }
                                                                  } else {
                                                                    _vm.needReview = $$c
                                                                  }
                                                                }
                                                              }
                                                            }),
                                                            _c("span", [
                                                              _vm._v(
                                                                "Attention needed"
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm.pickl.status ===
                                                  "APPROVED" ||
                                                (!_vm.brand &&
                                                  _vm.pickl.status ===
                                                    "REJECTED")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pickl-rating-rated"
                                                  },
                                                  [
                                                    _vm.pickl.user_pickl
                                                      .need_review === "Yes"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "pickl-rating-attention"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "completion-time"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "ATTENTION NEEDED"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pickl-rating-note-block"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "pickl-rating-note-label"
                                                          },
                                                          [_vm._v("Notes")]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "pickl-rating-note-text"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pickl
                                                                  .user_pickl
                                                                  .admin_note ||
                                                                  "None"
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm.pickl.user_pickl
                                                      .admin_rating != null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "pickl-rating-display"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v("Rated ")
                                                            ]),
                                                            _vm._l(
                                                              _vm.pickl
                                                                .user_pickl
                                                                .admin_rating,
                                                              function(n) {
                                                                return _c(
                                                                  "img",
                                                                  {
                                                                    key: n,
                                                                    staticClass:
                                                                      "rating-star-sm",
                                                                    attrs: {
                                                                      src:
                                                                        "/img/Alerts/picklerating_icon.png",
                                                                      alt:
                                                                        "Rated star"
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            !_vm.brand &&
                                            _vm.pickl.status === "REJECTED" &&
                                            _vm.pickl
                                              .can_reverse_reject_pickl === true
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pickl-rating-reverse"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn-reverse-reject",
                                                        attrs: {
                                                          type: "button"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.reverseRejectPickl
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Reverse rejection"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        !_vm.brand &&
                                        _vm.pickl.status === "COMPLETED"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pickl-rating-actions"
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-reject-sm",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: _vm.rejectPickl
                                                    }
                                                  },
                                                  [_vm._v("Reject")]
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-approve-sm",
                                                    attrs: {
                                                      type: "button",
                                                      disabled:
                                                        _vm.changingStatus
                                                    },
                                                    on: {
                                                      click: _vm.approvePickl
                                                    }
                                                  },
                                                  [_vm._v("Approve")]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ])
            ])
          ]),
          _c("button", {
            ref: "openConfirmModalTrigger",
            staticStyle: { display: "none" },
            attrs: {
              type: "button",
              "data-toggle": "modal",
              "data-target": "#approved-pickl-popup"
            }
          }),
          _c("ConfirmPicklStatus", {
            ref: "approvedPicklPopup",
            attrs: {
              popupId: "approved-pickl-popup",
              type: _vm.confirmationType
            },
            on: { confirmed: _vm.confirmed }
          }),
          _vm.pickl.user_pickl
            ? _c("TaskSyncLogPopup", {
                ref: "taskSyncLogPopup",
                attrs: {
                  popupId: "task-sync-log-popup",
                  userPickl: _vm.pickl.user_pickl
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }